export default {
	name: 'her01-hero',
	data() {
		return {
			category: ''
		};
	},
	created() {
		const searchParams = new URLSearchParams(window.location.search);
		if (searchParams.has('category')) this.setCategory(searchParams.get('category'));
	},
	methods: {
		setCategory(category) {
			this.category = this.category == category ? '' : category;
		}
	}
};



// WEBPACK FOOTER //
// ../source/modules/HER01-hero/HER01-hero.js